const APP = require('APP')
const _ = require('underscore')
const $ = require('jquery')
const router = require('router')
const win = require('Helpers/win')
require('tpl')
const divCaptchaWidgetTpl = require('../Block/div_captcha_widget.html.twig')

const Captcha = function Captcha(form, params) {
  if (form.data('captcha')) {
    return null
  }

  let captchaBox
  const formId = form.data('form-id') || 'form_captcha'
  let captchaReload = form.find('i.captcha-reload')

  // eslint-disable-next-line no-param-reassign
  params = _.extend(
    {},
    {
      className: 'form-item form-item-text',
    },
    params,
  )

  if (captchaReload.length) {
    captchaBox = captchaReload.parent().parent()
  }

  if (!captchaBox || !captchaBox.length) {
    const t = new Date().getTime()
    const src = router.path('gregwar_captcha.generate_captcha', { key: '_captcha_captcha', t })

    const captchaTemplate = divCaptchaWidgetTpl({
      image_id: `captcha_${t}`,
      captcha_code: src,
      captcha_width: '200',
      captcha_height: '70',
      reload: true,
      id: `${formId}_captcha`,
      name: `${formId}[captcha]`,
    })

    if (params.className.indexOf('label-left')) {
      captchaBox = $(
        `<div class="${params.className}">` + `<div class="item-container">${captchaTemplate}</div>` + '</div>',
      )
    } else {
      captchaBox = $(`<div class="${params.className}">${captchaTemplate}</div>`)
    }
    captchaReload = captchaBox.find('i.captcha-reload')
  }

  const reload = function reload() {
    captchaReload.trigger('click')
  }

  if (APP.virtualKeyboard) {
    APP.virtualKeyboard.appendTo(captchaBox)
  }

  return {
    el: captchaBox,
    reload,
  }
}

win.$doc.on('click', 'i.captcha-reload', () => {
  const icon = this
  const captchaImg = $(`#${this.getAttribute('data-captcha-id')}`)
  const url = `${this.getAttribute('data-captcha-url')}?u=${new Date().getTime()}`

  icon.className += ' rotate'

  if (captchaImg[0]) {
    captchaImg[0].onload = () => {
      captchaImg[0].onload = undefined
      icon.className = icon.className.split('rotate').join('')
    }

    captchaImg[0].src = url
  } else {
    throw new Error('No captcha image found')
  }
})

module.exports = Captcha
